const EOFFICE_PERMISSION_PATHS = Object.freeze({
  supplyProposals: "eoffice.supply_proposals",
  purchasePrices: "eoffice.purchase_prices",
  purchaseRequests: "eoffice.purchase_requests",
  purchaseOrders: "eoffice.purchase_orders",
  tickets: "eoffice.tickets",
  paymentRequests: "eoffice.payment_requests",
  advanceRequests: "eoffice.advance_requests",
  businessTrips: "eoffice.business_trips",
  rewardProposals: "eoffice.reward_proposals",
  trainingRequests: "eoffice.training_requests",
  qualificationSupplements: "eoffice.qualification_supplements",
  employeeInfoChanges: "eoffice.employee_info_changes",
  disciplinaryProposals: "eoffice.disciplinary_proposals",
  resignationRequests: "eoffice.resignation_requests",
  leaveRequests: "eoffice.leave_requests",
  overtimeRequests: "eoffice.overtime_requests",
  lateEarlyRequests: "eoffice.late_early_requests",
  missingAttendanceRequests: "eoffice.missing_attendance_requests",
  recruitmentRequests: "eoffice.recruitment_requests",
  employeeDirectory: "eoffice.employee_directory",
  weeklySchedules: "eoffice.weekly_schedules",
  sharedDocuments: "eoffice.shared_documents",
  internalLibrary: "eoffice.internal_library",
  companyNews: "eoffice.company_news",
  digitalSignatures: "eoffice.digital_signatures",
  meetingRooms: "eoffice.meeting_rooms",
  businessCars: "eoffice.business_cars",
  officeSupplies: "eoffice.office_supplies",
  incomingDocuments: "eoffice.incoming_documents",
  outgoingDocuments: "eoffice.outgoing_documents",
  ticketCategories: "eoffice.ticket_categories",
  supplyConfiguration: "eoffice.supply_configuration",
  sharedLibraryCatalog: "eoffice.shared_library_catalog",
  meetingRoomCatalog: "eoffice.meeting_room_catalog",
  businessCarCatalog: "eoffice.business_car_catalog",
  officeSupplyCatalog: "eoffice.office_supply_catalog",
});

const EOFFICE_SECTION_PATHS = Object.freeze({
  purchase: [
    EOFFICE_PERMISSION_PATHS.supplyProposals,
    EOFFICE_PERMISSION_PATHS.purchasePrices,
    EOFFICE_PERMISSION_PATHS.purchaseRequests,
    EOFFICE_PERMISSION_PATHS.purchaseOrders,
  ],
  digitalProcess: [
    EOFFICE_PERMISSION_PATHS.tickets,
    EOFFICE_PERMISSION_PATHS.paymentRequests,
    EOFFICE_PERMISSION_PATHS.advanceRequests,
    EOFFICE_PERMISSION_PATHS.businessTrips,
    EOFFICE_PERMISSION_PATHS.rewardProposals,
    EOFFICE_PERMISSION_PATHS.trainingRequests,
    EOFFICE_PERMISSION_PATHS.qualificationSupplements,
    EOFFICE_PERMISSION_PATHS.employeeInfoChanges,
    EOFFICE_PERMISSION_PATHS.disciplinaryProposals,
    EOFFICE_PERMISSION_PATHS.resignationRequests,
    EOFFICE_PERMISSION_PATHS.leaveRequests,
    EOFFICE_PERMISSION_PATHS.overtimeRequests,
    EOFFICE_PERMISSION_PATHS.lateEarlyRequests,
    EOFFICE_PERMISSION_PATHS.missingAttendanceRequests,
    EOFFICE_PERMISSION_PATHS.recruitmentRequests,
  ],
  digitalOffice: [
    EOFFICE_PERMISSION_PATHS.employeeDirectory,
    EOFFICE_PERMISSION_PATHS.weeklySchedules,
    EOFFICE_PERMISSION_PATHS.sharedDocuments,
    EOFFICE_PERMISSION_PATHS.internalLibrary,
    EOFFICE_PERMISSION_PATHS.companyNews,
    EOFFICE_PERMISSION_PATHS.digitalSignatures,
    EOFFICE_PERMISSION_PATHS.meetingRooms,
    EOFFICE_PERMISSION_PATHS.businessCars,
    EOFFICE_PERMISSION_PATHS.officeSupplies,
    EOFFICE_PERMISSION_PATHS.incomingDocuments,
    EOFFICE_PERMISSION_PATHS.outgoingDocuments,
  ],
  workflowCatalog: [
    EOFFICE_PERMISSION_PATHS.ticketCategories,
    EOFFICE_PERMISSION_PATHS.supplyConfiguration,
    EOFFICE_PERMISSION_PATHS.sharedLibraryCatalog,
    EOFFICE_PERMISSION_PATHS.meetingRoomCatalog,
    EOFFICE_PERMISSION_PATHS.businessCarCatalog,
    EOFFICE_PERMISSION_PATHS.officeSupplyCatalog,
  ],
});

const ROUTE_PERMISSIONS = Object.freeze({
  PurchaseProcessHome: EOFFICE_SECTION_PATHS.purchase,
  SupplyProposals: [EOFFICE_PERMISSION_PATHS.supplyProposals],
  PurchasePrices: [EOFFICE_PERMISSION_PATHS.purchasePrices],
  PurchaseRequests: [EOFFICE_PERMISSION_PATHS.purchaseRequests],
  PurchaseOrders: [EOFFICE_PERMISSION_PATHS.purchaseOrders],
  DigitalProcessHome: EOFFICE_SECTION_PATHS.digitalProcess,
  Tickets: [EOFFICE_PERMISSION_PATHS.tickets],
  PaymentRequests: [EOFFICE_PERMISSION_PATHS.paymentRequests],
  AdvanceRequests: [EOFFICE_PERMISSION_PATHS.advanceRequests],
  BusinessTrips: [EOFFICE_PERMISSION_PATHS.businessTrips],
  RewardProposals: [EOFFICE_PERMISSION_PATHS.rewardProposals],
  TrainingRequests: [EOFFICE_PERMISSION_PATHS.trainingRequests],
  QualificationSupplements: [EOFFICE_PERMISSION_PATHS.qualificationSupplements],
  EmployeeInfoChanges: [EOFFICE_PERMISSION_PATHS.employeeInfoChanges],
  DisciplinaryProposals: [EOFFICE_PERMISSION_PATHS.disciplinaryProposals],
  ResignationRequests: [EOFFICE_PERMISSION_PATHS.resignationRequests],
  LeaveRequests: [EOFFICE_PERMISSION_PATHS.leaveRequests],
  OvertimeRequests: [EOFFICE_PERMISSION_PATHS.overtimeRequests],
  LateEarlyRequests: [EOFFICE_PERMISSION_PATHS.lateEarlyRequests],
  MissingAttendanceRequests: [EOFFICE_PERMISSION_PATHS.missingAttendanceRequests],
  RecruitmentRequests: [EOFFICE_PERMISSION_PATHS.recruitmentRequests],
  DigitalOfficeApps: EOFFICE_SECTION_PATHS.digitalOffice,
  EmployeeDirectory: [EOFFICE_PERMISSION_PATHS.employeeDirectory],
  WeeklySchedules: [EOFFICE_PERMISSION_PATHS.weeklySchedules],
  SharedDocuments: [EOFFICE_PERMISSION_PATHS.sharedDocuments],
  SharedLibrary: [EOFFICE_PERMISSION_PATHS.internalLibrary],
  SharedLibraryAdmin: [EOFFICE_PERMISSION_PATHS.internalLibrary],
  SharedLibraryFolder: [EOFFICE_PERMISSION_PATHS.internalLibrary],
  CompanyNews: [EOFFICE_PERMISSION_PATHS.companyNews],
  CompanyNewsDetail: [EOFFICE_PERMISSION_PATHS.companyNews],
  DigitalSignatureTemplates: [EOFFICE_PERMISSION_PATHS.digitalSignatures],
  PdfSignatureEditor: [EOFFICE_PERMISSION_PATHS.digitalSignatures],
  MeetingRooms: [EOFFICE_PERMISSION_PATHS.meetingRooms],
  BusinessCars: [EOFFICE_PERMISSION_PATHS.businessCars],
  OfficeSupplies: [EOFFICE_PERMISSION_PATHS.officeSupplies],
  IncomingDocuments: [EOFFICE_PERMISSION_PATHS.incomingDocuments],
  OutgoingDocuments: [EOFFICE_PERMISSION_PATHS.outgoingDocuments],
  TicketCategories: [EOFFICE_PERMISSION_PATHS.ticketCategories],
  SupplyConfiguration: [EOFFICE_PERMISSION_PATHS.supplyConfiguration],
  SupplyWorkflows: [EOFFICE_PERMISSION_PATHS.supplyConfiguration],
  SharedLibraryCatalog: [EOFFICE_PERMISSION_PATHS.sharedLibraryCatalog],
  MeetingRoomCatalog: [EOFFICE_PERMISSION_PATHS.meetingRoomCatalog],
  BusinessCarCatalog: [EOFFICE_PERMISSION_PATHS.businessCarCatalog],
  OfficeSupplyCatalog: [EOFFICE_PERMISSION_PATHS.officeSupplyCatalog],
});

function getEofficeRoutePermissions(routeName) {
  return ROUTE_PERMISSIONS[routeName] || [];
}

function isEofficePermissionAllowed(permission) {
  return permission !== null;
}

function hasEofficeAccess(permissions = {}) {
  const values = Object.values(EOFFICE_PERMISSION_PATHS).map((path) => permissions[path]);
  if (values.every((value) => value === undefined)) return true;
  return values.some((value) => value !== undefined && isEofficePermissionAllowed(value));
}

module.exports = {
  EOFFICE_PERMISSION_PATHS,
  EOFFICE_SECTION_PATHS,
  ROUTE_PERMISSIONS,
  getEofficeRoutePermissions,
  hasEofficeAccess,
  isEofficePermissionAllowed,
};
